@if (visible() && isSurveyOpen() && !isRated()) {
<app-survey
  [interaction]="interaction"
  (done)="surveyCompleted($event)"
  (skipped)="surveySkipped()"
  [@slideInOut]="true"
></app-survey>
} @if (visible() && isRated()) {
<av-card class="rating" [backdrop]="false" [@slideInOut]="true">
  <av-card-body type="container">
    <div class="fx-column fx-align-center fx-justify-center">
      <av-icon name="starred" mode="light" class="starred"></av-icon>
      <h1 translate>Thank you!</h1>
    </div>
  </av-card-body>
</av-card>
} @if (visible() && isFeedbackAvailable() && !isSurveyOpen() && !isRated()) {
<av-card
  role="dialog"
  [attr.aria-label]="'Please provide feedback' | translate"
  [backdrop]="false"
  class="rating"
  [@slideInOut]="true"
>
  <av-card-header
    (close)="cancel()"
    subtitle="How was the audio and video quality ?"
  >
    <span translate>Video & Audio Quality</span>
  </av-card-header>
  <av-card-body>
    <div class="fx-column fx-align-stretch fx-justify-center">
      <div class="stars" role="radiogroup">
        @for (point of points; track point) {
        <button
          role="radio"
          (mouseenter)="fill(point)"
          (mouseleave)="empty()"
          (click)="rate(point)"
          [class.star-rate]="isActive(point)"
          [class.star-dark]="isDarkMode()"
          [attr.aria-checked]="feedback.score === point"
          class="star"
          data-tid="rating/stars"
        ></button>
        }
      </div>
      @if (isLowRating) {
      <textarea
        avInput
        name="comment"
        [maxlength]="maxChars"
        [(ngModel)]="feedback.comment"
        placeholder="{{ 'What went wrong?' | translate }}"
        rows="5"
      ></textarea>
      <div>
        <small class="text-muted pull-right"
          >{{ feedback.comment.length }}/{{ maxChars }}</small
        >
      </div>
      }
      <div
        class="fx-row actions fx-align-center"
        [class.fx-justify-space-between]="isLowRating"
        [class.fx-justify-center]="!isLowRating"
      >
        <button
          avButton
          (click)="cancel()"
          ofType="basic"
          translate
          data-tid="rating/skip"
        >
          skip
        </button>
        @if (isLowRating) {
        <button avButton color="accent" (click)="next()" data-tid="rating/send">
          @if (!isSurveyAvailable()) {
          <span translate> Send feedback </span>
          } @if (isSurveyAvailable()) {
          <span translate> Next </span>
          }
        </button>
        }
      </div>
    </div>
  </av-card-body>
</av-card>
}
